import { ProgramConfig } from '@/types/apiModels'

// Single source of truth for reading the partial-import feature gate (spec: Program-Config
// Feature Gate). RETERRA is the first program with this flag enabled; no program-ID branching.
export const isPartialImportEnabled = (programConfig: ProgramConfig | null | undefined): boolean =>
  programConfig?.partialImportConfig?.enabled === true
